import { render, staticRenderFns } from "./DriverGroupList.vue?vue&type=template&id=3d17b0fa&"
import script from "./DriverGroupList.vue?vue&type=script&lang=js&"
export * from "./DriverGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports